import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormlyModule} from '@ngx-formly/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FormlyFieldDatePickerComponent} from './formly-field-date-picker.component';
import {I18nModule} from '@spartacus/core';
import {DcpDateFormatter, IconButtonTooltipComponent} from '@dcp/configurator';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'date-picker',
          component: FormlyFieldDatePickerComponent,
        },
      ],
    }),
    FormsModule,
    DcpDateFormatter,
    IconButtonTooltipComponent,
    FormlyFieldDatePickerComponent,
  ],
  exports: [FormlyFieldDatePickerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FormlyDatePickerModule {}
